module.exports = __webpack_public_path__ + "static/media/blueBingoBall.03907b58.png";